import { css } from 'lit';
export class KryptonAppStyles {
    static stylesApp = [css`
        :host {
            display: block;
            box-sizing: border-box;
        }

        #page-manager {
            padding-top: var(--header-height);
        }
        ::slotted(menu-item){
            border-bottom: 1px #eee solid;
        }
        ::slotted(menu-item:last-of-type){
            border-bottom: none!important
        }
    `];

    static stylesHeader =
        [
            css`
            #header {
                position: relative;
                -ms-grid-row: 1;
                -ms-grid-column: 2;
                grid-row: 1;
                grid-column: 2;
                grid-area: primary-header;
                display: -ms-grid;
                display: grid;
                -ms-grid-rows: 1fr;
                grid-template-rows: 1fr;
                -ms-grid-columns: 1fr auto auto 20fr;
                grid-template-columns: 1fr auto auto 20fr;
                grid-template-areas: "menu-icon title version nav-container";
                align-items: center;
                position: fixed;
                -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
                top: 0;
                height: var(--header-height);
                width: 100%;
                color: var(--header-color);
                background-color: var(--header-bg-color);
                border-bottom: 1px solid var(--header-border-color);
                padding: 0;
                margin: 0;
                -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
                -moz-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
                box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
                z-index: var(--z-index-krypton-base-header);
                font-family: var(--krypton-font-family-header);
                font-weight: var(--krypton-font-weight-header);
                font-size: 1em;
                box-sizing: border-box;
                transition: height 150ms linear;
            }

            #menu-icon {
                grid-area: menu-icon;
                -ms-grid-row: 1;
                -ms-grid-column: 1;
                grid-row: 1;
                grid-column: 1;
                transition: transform 0.5s ease-out;
                -webkit-transition: transform 0.5s ease-out;
                -moz-transition: transform 0.5s ease-out;
                -o-transition: transform 0.5s ease-out;
                transition: transform var(--nav-transition-timing) var(--nav-transition-function);
                -webkit-transition: transform var(--nav-transition-timing) var(--nav-transition-function);
                -moz-transition: transform var(--nav-transition-timing) var(--nav-transition-function);
                -o-transition: transform var(--nav-transition-timing) var(--nav-transition-function);
                margin: 15px 5px 15px 15px;
                background-size: contain;
                height: 20px;
                width: 22px;
                display: inline-block;
                cursor: pointer;
                fill: var(--header-menu-color);
            }

            #header-title {
                grid-area: title;
                -ms-grid-row: 1;
                -ms-grid-column: 2;
                grid-row: 1;
                grid-column: 2;
                cursor: pointer;
                margin: 0 7px 0 0;
                padding-left: 0.2em;
                padding-right: 0.25em;
                font-size: 2.6em;
                font-weight: var(--krypton-font-weight-header);
                transition: all 0.5s ease-out;
                -webkit-transition: all 0.5s ease-out;
                -moz-transition: all 0.5s ease-out;
                -o-transition: all 0.5s ease-out;
                transition: all var(--title-transition-timing) var(--title-transition-function);
                -webkit-transition: all var(--title-transition-timing) var(--title-transition-function);
                -moz-transition: all var(--title-transition-timing) var(--title-transition-function);
                -o-transition: all var(--title-transition-timing) var(--title-transition-function);
                opacity: 1;
                white-space: nowrap;
            }

            #header-version {
                grid-area: version;
                -ms-grid-row: 1;
                -ms-grid-column: 3;
                grid-row: 1;
                grid-column: 3;
                position: relative;
                font-size: 1em;
                top: -0.6em;
                transition: all 150ms ease-out;
                -webkit-transition: all 150ms ease-out;
                -moz-transition: all 150ms ease-out;
                -o-transition: all 150ms ease-out;
                transition: all var(--title-transition-timing) var(--title-transition-function);
                -webkit-transition: all var(--title-transition-timing) var(--title-transition-function);
                -moz-transition: all var(--title-transition-timing) var(--title-transition-function);
                -o-transition: all var(--title-transition-timing) var(--title-transition-function);
                opacity: 1;
                margin-bottom: -15px;
                margin-top: -15px;
            }

            #header-nav-container {
                 grid-area: nav-container;
                -ms-grid-row: 1;
                -ms-grid-column: 5;
                grid-row: 1;
                grid-column: 5;
                position: relative;
                justify-content: flex-end;
                flex: 1 1 8em;
                flex-wrap: wrap;
                margin-right: 1em;
                align-content: right;
                align-items: right;
                display: -ms-grid;
                display: grid;
                -ms-grid-rows: 1fr;
                grid-template-rows: 1fr;
                -ms-grid-columns: auto auto;
                grid-template-columns: auto auto;
                grid-template-areas: "clock nav";
                align-items: center;
            }

            #header-clock {
                color: var(--header-clock-color);
                grid-area: clock;
                -ms-grid-row: 1;
                -ms-grid-column: 4;
                grid-row: 1;
                grid-column: 4;
                justify-content: flex-end;
                margin-right: 1.35em;
                font-size: .9em;
            }

            #header-nav {
                grid-area: nav;
                -ms-grid-row: 1;
                -ms-grid-column: 5;
                grid-row: 1;
                grid-column: 5;
                display: flex;
                flex: 1 1 8em;
                margin-right: 1em;
                align-content: center;
                align-items: center;
                align-items: center;
                justify-content: flex-end;
            }

            #header-nav ::slotted(a) {
                font-size: 1em;
                list-style: none;
                margin: 0 1.35em 0 0;
                text-align: center;
                cursor: pointer;
                text-decoration: none;
                color: var(--header-link-color);
            }

            #header-nav ::slotted(a:hover)  {
                text-decoration: underline;
            }
            
            #header-nav a {
                font-size: 1em;
                list-style: none;
                margin: 0 1.35em 0 0;
                text-align: center;
                cursor: pointer;
                text-decoration: none;
                color: var(--header-link-color);
            }

            #header-nav a:hover  {
                text-decoration: underline;
            }
            
            #header-mobile-nav {
                border-top: 1px solid #EEE;
                padding-top: 2rem;
            }

            #header-mobile-nav > li {
                list-style: none;
                padding-left: 1rem;
                margin: 0.75rem auto;
            }

            #header-mobile-nav > li > a {
                font-size: 1rem;
                line-height: 1.3rem;
                color: var(--header-link-color);
            }
            
            #header-mobile-nav > li > a:hover  {
                text-decoration: underline;
            }

            #menu-icon.active {
                transform: translateX(var(--krypton-base-nav-width));
                -webkit-transform: translateX(var(--krypton-base-nav-width));
                -moz-transform: translateX(var(--krypton-base-nav-width));
            }
            #header-title.menu-event,
            #header-version.menu-event {
                pointer-events: none;
                cursor: default;
                opacity: 0;
            }

            .link-disabled{  color: #9ab3cd;
                pointer-events: none;
                text-decoration: none;
            }

            @media only screen and (max-width: 767px) {
                #header {
                    -webkit-box-shadow: none;
                    -moz-box-shadow: none;
                    box-shadow: none;
                }
            }`
            ,
            //--shrink
            css`
            #header.shrink {
                height: 1.25em;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }

            #header.shrink > *:not(#header-nav-container) {
                display: none;
            }

            #header.shrink #header-clock {
                justify-content: center;
                line-height: 2em;
                font-size: 0.9em;
                width: 100vw;
            }`
            ,
            //--disabled
            css`
            #header.disabled #menu-icon,
            #header.disabled #header-title {
                pointer-events: none;
                cursor: default !important;
            }

            #header.disabled #menu-icon {
                opacity: 0.5;
            }

            #header.disabled #header-nav {
                display: none;
            }

            #header.disabled #header-nav ::slotted(*) {
                display: none;
            }

            #menu-icon.disabled {
                opacity: 0.5;
                pointer-events: none;
                cursor: default;
            }`
            ,
            css`@media only screen and (min-width: 768px) {
                .header-hidden-md-up { 
                    display: none !important;
                }
            }`,
            //--tablet
            css`
            @media only screen and (min-width: 768px) and (max-width: 991px) {
                #header {
                    -ms-grid-columns: auto auto auto 1fr;
                    grid-template-columns: auto auto auto 1fr;
                    grid-template-areas: "menu-icon title version nav-container";
                }
                #header-nav-container {
                    -ms-grid-columns: 1fr;
                    grid-template-columns: 1fr;
                    grid-template-areas: "tablet-clock-nav";
                }
                #header-title {
                    font-size: 2em;
                }
                
                #header-clock {
                    grid-area: tablet-clock-nav;
                    margin-top: 1.35em;
                    margin-right: 3.45em;
                }

                #header-nav {
                    grid-area: tablet-clock-nav;
                    margin-bottom: 1.5em;
                    margin-right: 2.1em;
                    line-height: 12px;
                }
                
                .header-hidden-md {
                    display: none !important;
                }

                #menu-icon.active {
                    transform: translateX(50vw);
                    -webkit-transform: translateX(50vw);
                    -moz-transform: translateX(50vw);
                }

                #header-title.menu-event,
                #header-version.menu-event {
                    opacity: 0;
                }
            }`
            ,
            //--mobile
            css`
            @media only screen and (min-width: 320px) and (max-width: 767px) {
                #header {
                    -ms-grid-columns: 1fr 3fr auto 8fr;
                    grid-template-columns: 1fr 3fr auto 8fr;
                    grid-template-areas: "menu-icon title version nav-container";
                }

                #header-title {
                    font-size: 1.9em;
                    white-space: normal;
                    padding-left: 0.25em;
                    padding-right: 0.25em;
                }

                #header-title .company-name{
                    font-size: 1.5rem;
                }

                #header-nav {
                    display: none;
                }

                #header-clock {
                    font-size: .9em;
                    text-align: right;
                    line-height: 1rem;
                    top: -0.3rem;
                    position: relative;
                }
                #header-version {
                    line-height: 12px;
                    top: -0.4em;
                }
                #header-title.menu-event,
                #header-version.menu-event {
                    opacity: 0;
                }

                #menu-icon.active {
                    transform: translateX(80vw);
                    -webkit-transform: translateX(80vw);
                    -moz-transform: translateX(80vw);
                }
            }`
        ];

    static stylesFooter =
        [
            css`
            #footer {
                display: block;
                width: 100%;
                padding: 1rem;
                color: var(--krypton-color-gray-dark);
                box-sizing: border-box;
            }

            #footer-body {
                text-align: center;
                font-family: var(--krypton-font-family-header);
                padding: 1rem;
                box-sizing: border-box;
                border-top: 1px solid #cecdcb;
            }
            
            #footer-body > div {
                display: block;
            }

            #footer-header {
                display: none;
            }
            
            .d-none{
                display: none !important;
            }
            `,
            //--mobile
            css`
            @media only screen and (min-width: 320px) and (max-width: 768px)
            , only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {

                #footer {
                    position: fixed;
                    bottom: 0;
                    padding: 0;
                    background-color: white;
                    z-index: var(--z-index-krypton-base-footer);
                }

                #footer-header {
                    display: block;
                    height: 1.5rem;
                    line-height: 1.5rem;
                    text-align: center;
                    cursor: pointer;
                    border-top: 1px solid var(--krypton-color-gray-mid);
                }

                #footer-body {
                    height: 0;
                    padding: 0;
                    margin: 0;
                    transition: height 200ms ease-out;
                }

                #footer.mobile-open {
                    background-color: var(--krypton-color-grey);
                    -webkit-box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5);
                    -moz-box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5);
                    box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5);
                }

                #footer.mobile-open #footer-header {
                    border-top: 1px solid var(--krypton-color-gray-dark);
                    color: var(--krypton-color-eternal-blue);
                    font-size: 2rem;
                    line-height: 3rem;
                    height: 3rem;
                }

                #footer.mobile-open #footer-body {
                    height: 10rem;
                    margin: 0.6rem;
                    display: inline-block;
                }

                #footer-body > div {
                    display: inline;
                }

                .text-nowrap {
                    white-space: nowrap !important;
                }
            }`
        ];
}
